// import React from 'react';
// import { FaUpload, FaTimesCircle } from "react-icons/fa";

// const Step3_Tax = ({
//     vendorData,
//     handleVendorChange,
//     isDisabled,
//     vendorOnboardInfo,
//     uploaded,
//     fileNames,
//     handleFileChange,
//     handleStandardFileChange,
//     handleRemoveFile,
//     panFileRef,
//     gstFileRef,
//     msmeRef,
//     assessmentRef,
//     ndaRef
// }) => {

//     const isStlDigital = vendorOnboardInfo?.company &&
//         (vendorOnboardInfo.company.trim().replace('-', '').toLowerCase() === 'stldigital' ||
//             vendorOnboardInfo.company.trim().toLowerCase() === 'stl-digital');

//     const isIndia = vendorData.country === 'IN' || !vendorData.country;

//     return (
//         <div className="vendor-card">
//             <h3>Tax & Compliance Documents</h3>
//             <div className="two-col-grid">

//                 {/* PAN/TAN NUMBER */}
//                 {isIndia ? (
//                     <div className="input-wrapper">
//                         <span className="input-label">{isStlDigital ? 'PAN Number*' : 'PAN/TAN Number*'}</span>
//                         <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.pan ? 'default' : 'pointer') }} onClick={(e) => {
//                             if (!isDisabled && !uploaded.pan) {
//                                 panFileRef.current?.click();
//                             }
//                         }}>
//                             <input
//                                 type="text"
//                                 name="pan_tan"
//                                 placeholder={isStlDigital ? 'PAN Number*' : 'PAN/TAN Number*'}
//                                 value={vendorData.pan_tan}
//                                 onChange={(e) => {
//                                     let value = e.target.value.toUpperCase();
//                                     let formattedValue = '';
//                                     for (let i = 0; i < value.length && formattedValue.length < 10; i++) {
//                                         const char = value[i];
//                                         const pos = formattedValue.length;
//                                         if (pos < 5) { if (/[A-Z]/.test(char)) formattedValue += char; }
//                                         else if (pos < 9) { if (/[0-9]/.test(char)) formattedValue += char; }
//                                         else if (pos < 10) { if (/[A-Z]/.test(char)) formattedValue += char; }
//                                     }
//                                     handleVendorChange({ target: { name: 'pan_tan', value: formattedValue } });
//                                 }}
//                                 disabled={isDisabled}
//                                 readOnly={!uploaded.pan}
//                                 style={{ cursor: uploaded.pan ? 'text' : 'pointer' }}
//                                 onClick={(e) => {
//                                     if (!isDisabled && !uploaded.pan) {
//                                         e.stopPropagation();
//                                         panFileRef.current?.click();
//                                     } else if (uploaded.pan) {
//                                         e.stopPropagation();
//                                     }
//                                 }}
//                             />
//                             {uploaded.pan ? (
//                                 <FaTimesCircle
//                                     className="remove-icon"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         handleRemoveFile('pan');
//                                     }}
//                                 />
//                             ) : (
//                                 <FaUpload className="upload-icon" />
//                             )}
//                             <input
//                                 type="file"
//                                 ref={panFileRef}
//                                 style={{ display: 'none' }}
//                                 accept=".pdf,.jpg,.jpeg,.png"
//                                 onChange={(e) => handleFileChange(e, 'pan_tan_file')}
//                                 disabled={isDisabled}
//                             />
//                         </div>
//                     </div>
//                 ) : (
//                     // VAT Number for Non-India
//                     <div className="input-wrapper">
//                         <span className="input-label">VAT Number (Optional)</span>
//                         <input
//                             type="text"
//                             className="input-field"
//                             name="vat_number"
//                             placeholder="VAT Number (Optional)"
//                             value={vendorData.vat_number}
//                             onChange={handleVendorChange}
//                             disabled={isDisabled}
//                         />
//                     </div>
//                 )}

//                 {/* GST NUMBER */}
//                 {isIndia ? (
//                     <div className="input-wrapper">
//                         <span className="input-label">GST Number{isStlDigital ? ' (Optional)' : '*'}</span>
//                         <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.gst ? 'default' : 'pointer') }} onClick={(e) => {
//                             if (!isDisabled && !uploaded.gst) {
//                                 gstFileRef.current?.click();
//                             }
//                         }}>
//                             <input
//                                 type="text"
//                                 name="gst_number"
//                                 placeholder="GST Number*"
//                                 value={vendorData.gst_number}
//                                 onChange={(e) => {
//                                     let value = e.target.value.toUpperCase();
//                                     let formattedValue = '';
//                                     for (let i = 0; i < value.length && formattedValue.length < 15; i++) {
//                                         const char = value[i];
//                                         const pos = formattedValue.length;
//                                         if (pos < 2) { if (/[0-9]/.test(char)) formattedValue += char; }
//                                         else if (pos < 7) { if (/[A-Z]/.test(char)) formattedValue += char; }
//                                         else if (pos < 11) { if (/[0-9]/.test(char)) formattedValue += char; }
//                                         else if (pos === 11) { if (/[A-Z]/.test(char)) formattedValue += char; }
//                                         else if (pos === 12) { if (/[0-9]/.test(char)) formattedValue += char; }
//                                         else if (pos < 15) { if (/[A-Z]/.test(char)) formattedValue += char; }
//                                     }
//                                     handleVendorChange({ target: { name: 'gst_number', value: formattedValue } });
//                                 }}
//                                 disabled={isDisabled}
//                                 readOnly={!uploaded.gst}
//                                 maxLength={15}
//                                 style={{ cursor: uploaded.gst ? 'text' : 'pointer' }}
//                                 onClick={(e) => {
//                                     if (!isDisabled && !uploaded.gst) {
//                                         e.stopPropagation();
//                                         gstFileRef.current?.click();
//                                     } else if (uploaded.gst) {
//                                         e.stopPropagation();
//                                     }
//                                 }}
//                             />
//                             {uploaded.gst ? (
//                                 <FaTimesCircle
//                                     className="remove-icon"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         handleRemoveFile('gst');
//                                     }}
//                                 />
//                             ) : (
//                                 <FaUpload className="upload-icon" />
//                             )}
//                             <input
//                                 type="file"
//                                 ref={gstFileRef}
//                                 style={{ display: 'none' }}
//                                 accept=".pdf,.jpg,.jpeg,.png"
//                                 onChange={(e) => handleFileChange(e, 'gst_file')}
//                                 disabled={isDisabled}
//                             />
//                         </div>
//                     </div>
//                 ) : null}

//                 {/* MSME CERTIFICATE */}
//                 {isIndia && (
//                     <div className="input-wrapper">
//                         <span className="input-label">MSME Certificate{isStlDigital ? ' (Optional)' : '*'}</span>
//                         <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.msme ? 'default' : 'pointer') }} onClick={(e) => {
//                             if (!isDisabled && !uploaded.msme) {
//                                 msmeRef.current?.click();
//                             }
//                         }}>
//                             <input
//                                 type="text"
//                                 name="msme_number"
//                                 placeholder="MSME Number*"
//                                 value={vendorData.msme_number}
//                                 onChange={handleVendorChange}
//                                 disabled={isDisabled}
//                                 readOnly={!uploaded.msme}
//                                 style={{ cursor: uploaded.msme ? 'text' : 'pointer' }}
//                                 onClick={(e) => {
//                                     if (uploaded.msme && !isDisabled) {
//                                         e.stopPropagation();
//                                     }
//                                 }}
//                             />
//                             {uploaded.msme ? (
//                                 <FaTimesCircle
//                                     className="remove-icon"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         handleRemoveFile('msme');
//                                     }}
//                                 />
//                             ) : (
//                                 <FaUpload className="upload-icon" />
//                             )}
//                             <input
//                                 type="file"
//                                 ref={msmeRef}
//                                 style={{ display: 'none' }}
//                                 accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
//                                 onChange={(e) => handleFileChange(e, 'msme_certificate')}
//                                 disabled={isDisabled}
//                             />
//                         </div>
//                     </div>
//                 )}

//                 {/* ASSESSMENT REPORT */}
//                 <div className="input-wrapper">
//                     <span className="input-label">Assessment Report{isStlDigital ? ' (Optional)' : '*'}</span>
//                     <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && !uploaded.assessment && assessmentRef.current?.click()}>
//                         <input
//                             type="text"
//                             placeholder="Assessment Report*"
//                             readOnly
//                             value={uploaded.assessment ? fileNames.assessment : ""}
//                             disabled={isDisabled}
//                         />
//                         {uploaded.assessment ? (
//                             <FaTimesCircle
//                                 className="remove-icon"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleRemoveFile('assessment');
//                                 }}
//                             />
//                         ) : (
//                             <FaUpload className="upload-icon" />
//                         )}
//                         <input
//                             type="file"
//                             ref={assessmentRef}
//                             style={{ display: 'none' }}
//                             accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
//                             onChange={(e) => handleStandardFileChange(e, 'assessment_report', 'assessment', true)}
//                             disabled={isDisabled}
//                         />
//                     </div>
//                 </div>

//                 {/* NDA DOCUMENT */}
//                 <div className="input-wrapper">
//                     <span className="input-label">NDA Document (Optional)</span>
//                     <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && !uploaded.nda && ndaRef.current?.click()}>
//                         <input
//                             type="text"
//                             placeholder="NDA Document (Optional)"
//                             readOnly
//                             value={uploaded.nda ? fileNames.nda : ""}
//                             disabled={isDisabled}
//                         />
//                         {uploaded.nda ? (
//                             <FaTimesCircle
//                                 className="remove-icon"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleRemoveFile('nda');
//                                 }}
//                             />
//                         ) : (
//                             <FaUpload className="upload-icon" />
//                         )}
//                         <input
//                             type="file"
//                             ref={ndaRef}
//                             style={{ display: 'none' }}
//                             accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
//                             onChange={(e) => handleStandardFileChange(e, 'nda_document', 'nda')}
//                             disabled={isDisabled}
//                         />
//                     </div>
//                 </div>

//                 {/* CIN NUMBER (STL-Digital - Always Visible) */}
//                 {isStlDigital && (
//                     <div className="input-wrapper">
//                         <span className="input-label">CIN Number (Optional)</span>
//                         <input
//                             type="text"
//                             className="input-field"
//                             name="cin_number"
//                             placeholder="CIN Number (Optional)"
//                             value={vendorData.cin_number}
//                             onChange={handleVendorChange}
//                             disabled={isDisabled}
//                         />
//                     </div>
//                 )}



//             </div>
//         </div>
//     );
// };

// export default Step3_Tax;


import React, { useState, useEffect } from 'react';
import { FaUpload, FaTimesCircle } from "react-icons/fa";

const Step3_Tax = ({
    vendorData,
    handleVendorChange,
    isDisabled,
    vendorOnboardInfo,
    uploaded,
    fileNames,
    handleFileChange,
    handleStandardFileChange,
    handleRemoveFile,
    panFileRef,
    gstFileRef,
    msmeRef,
    assessmentRef,
    ndaRef
}) => {
    const [verificationState, setVerificationState] = useState({
        pan: { ocrSuccess: false, userModified: false },
        gst: { ocrSuccess: false, userModified: false },
        msme: { ocrSuccess: false, userModified: false }
    });


    // 1. Logic to detect if a value was filled by OCR (Keep this)
    useEffect(() => {
        if (uploaded.pan && vendorData.pan_tan && !verificationState.pan.userModified) {
            setVerificationState(prev => ({ ...prev, pan: { ...prev.pan, ocrSuccess: true } }));
        }
        if (uploaded.gst && vendorData.gst_number && !verificationState.gst.userModified) {
            setVerificationState(prev => ({ ...prev, gst: { ...prev.gst, ocrSuccess: true } }));
        }
        if (uploaded.msme && vendorData.msme_number && !verificationState.msme.userModified) {
            setVerificationState(prev => ({ ...prev, msme: { ...prev.msme, ocrSuccess: true } }));
        }
    }, [uploaded.pan, uploaded.gst, uploaded.msme, vendorData.pan_tan, vendorData.gst_number, vendorData.msme_number]);

    // 2. Reset state when a file is removed (Keep this)
    useEffect(() => {
        if (!uploaded.pan) setVerificationState(prev => ({ ...prev, pan: { ocrSuccess: false, userModified: false } }));
        if (!uploaded.gst) setVerificationState(prev => ({ ...prev, gst: { ocrSuccess: false, userModified: false } }));
        if (!uploaded.msme) setVerificationState(prev => ({ ...prev, msme: { ocrSuccess: false, userModified: false } }));
    }, [uploaded.pan, uploaded.gst, uploaded.msme]);

    // 3. MASTER SYNC: Pushes "Verified" status to the parent vendorData object
    useEffect(() => {
        const panStatus = getVerificationStatus("pan");
        const gstStatus = getVerificationStatus("gst");
        const msmeStatus = getVerificationStatus("msme");

        // Sync PAN status to parent vendorData
        if (vendorData.pan_tan_number_status !== panStatus) {
            handleVendorChange({
                target: { name: 'pan_tan_number_status', value: panStatus }
            });
        }

        // Sync GST status to parent vendorData (Good to have for consistency)
        if (vendorData.gst_number_status !== gstStatus) {
            handleVendorChange({
                target: { name: 'gst_number_status', value: gstStatus }
            });
        }
        if (vendorData.msme_number_status !== msmeStatus) {
            handleVendorChange({
                target: { name: 'msme_number_status', value: msmeStatus }
            });
        }
        // We watch verificationState so this runs every time a status flips
    }, [verificationState]);

    const getVerificationStatus = (docType) => {
        const doc = verificationState[docType];
        // 🔹 Verified only if OCR worked and user hasn't edited it
        if (doc?.ocrSuccess && !doc?.userModified) {
            return "Verified";
        }
        return "Not Verified";
    };

    const isStlDigital = vendorOnboardInfo?.company &&
        (vendorOnboardInfo.company.trim().replace('-', '').toLowerCase() === 'stldigital' ||
            vendorOnboardInfo.company.trim().toLowerCase() === 'stl-digital');

    const isIndia = vendorData.country === 'IN' || !vendorData.country;

    return (
        <div className="vendor-card">
            <h3>Tax & Compliance Documents</h3>
            <div className="two-col-grid">
                {/* PAN/TAN NUMBER */}
                {isIndia ? (
                    <div className="input-wrapper">
                        <span className="input-label">{isStlDigital ? 'PAN Number*' : 'PAN/TAN Number*'}</span>
                        <div
                            className="input-with-icon-vendor-form"
                            style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.pan ? 'default' : 'pointer') }}
                            onClick={(e) => {
                                if (!isDisabled && !uploaded.pan) {
                                    panFileRef.current?.click();
                                }
                            }}
                        >
                            <input
                                type="text"
                                name="pan_tan"
                                placeholder={isStlDigital ? 'PAN Number*' : 'PAN/TAN Number*'}
                                value={vendorData.pan_tan}
                                onChange={(e) => {
                                    let value = e.target.value.toUpperCase();
                                    let formattedValue = '';

                                    for (let i = 0; i < value.length && formattedValue.length < 10; i++) {
                                        const char = value[i];
                                        const pos = formattedValue.length;
                                        if (pos < 5) { if (/[A-Z]/.test(char)) formattedValue += char; }
                                        else if (pos < 9) { if (/[0-9]/.test(char)) formattedValue += char; }
                                        else if (pos < 10) { if (/[A-Z]/.test(char)) formattedValue += char; }
                                    }

                                    handleVendorChange({ target: { name: 'pan_tan', value: formattedValue } });

                                    // 🔹 UPDATED: If user types, it's no longer "OCR Verified"
                                    setVerificationState(prev => ({
                                        ...prev,
                                        pan: { ocrSuccess: false, userModified: true }
                                    }));
                                }}
                                disabled={isDisabled}
                                readOnly={!uploaded.pan}
                                style={{ cursor: uploaded.pan ? 'text' : 'pointer' }}
                            />
                            {uploaded.pan ? (
                                <FaTimesCircle
                                    className="remove-icon"
                                    style={{ color: 'green' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveFile('pan');
                                    }}
                                />
                            ) : (
                                <FaUpload className="upload-icon" />
                            )}
                            <input
                                type="file"
                                ref={panFileRef}
                                style={{ display: 'none' }}
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => handleFileChange(e, 'pan_tan_file')}
                                disabled={isDisabled}
                            />
                        </div>
                        {uploaded.pan && (
                            <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: getVerificationStatus("pan") === "Verified" ? "green" : "red"
                                }}>
                                    {getVerificationStatus("pan")}
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    /* ... VAT Logic ... */
                    <div className="input-wrapper">
                        <span className="input-label">VAT Number (Optional)</span>
                        <input
                            type="text"
                            className="input-field"
                            name="vat_number"
                            placeholder="VAT Number (Optional)"
                            value={vendorData.vat_number}
                            onChange={handleVendorChange}
                            disabled={isDisabled}
                        />
                    </div>
                )}

                {/* GST NUMBER */}
                {isIndia ? (
                    <div className="input-wrapper">
                        <span className="input-label">GST Number{isStlDigital ? ' (Optional)' : '*'}</span>
                        <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.gst ? 'default' : 'pointer') }} onClick={(e) => {
                            if (!isDisabled && !uploaded.gst) {
                                gstFileRef.current?.click();
                            }
                        }}>
                            <input
                                type="text"
                                name="gst_number"
                                placeholder="GST Number*"
                                value={vendorData.gst_number}
                                onChange={(e) => {
                                    let value = e.target.value.toUpperCase();
                                    let formattedValue = '';
                                    for (let i = 0; i < value.length && formattedValue.length < 15; i++) {
                                        const char = value[i];
                                        const pos = formattedValue.length;
                                        if (pos < 2) { if (/[0-9]/.test(char)) formattedValue += char; }
                                        else if (pos < 7) { if (/[A-Z]/.test(char)) formattedValue += char; }
                                        else if (pos < 11) { if (/[0-9]/.test(char)) formattedValue += char; }
                                        else if (pos === 11) { if (/[A-Z]/.test(char)) formattedValue += char; }
                                        else if (pos === 12) { if (/[0-9]/.test(char)) formattedValue += char; }
                                        else if (pos < 15) { if (/[A-Z]/.test(char)) formattedValue += char; }
                                    }
                                    handleVendorChange({ target: { name: 'gst_number', value: formattedValue } });

                                    // 🔹 UPDATED: If user types, it's no longer "OCR Verified"
                                    setVerificationState(prev => ({
                                        ...prev,
                                        gst: { ocrSuccess: false, userModified: true }
                                    }));
                                }}
                                disabled={isDisabled}
                                readOnly={!uploaded.gst}
                                maxLength={15}
                                style={{ cursor: uploaded.gst ? 'text' : 'pointer' }}
                            />
                            {uploaded.gst ? (
                                <FaTimesCircle
                                    className="remove-icon"
                                    style={{ color: 'green' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveFile('gst');
                                    }}
                                />
                            ) : (
                                <FaUpload className="upload-icon" />
                            )}
                            <input
                                type="file"
                                ref={gstFileRef}
                                style={{ display: 'none' }}
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => handleFileChange(e, 'gst_file')}
                                disabled={isDisabled}
                            />
                        </div>
                        {uploaded.gst && (
                            <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: getVerificationStatus("gst") === "Verified" ? "green" : "red"
                                }}>
                                    {getVerificationStatus("gst")}
                                </div>
                            </div>
                        )}
                    </div>
                ) : null}
                {/* MSME CERTIFICATE */}
                {isIndia && (
                    <div className="input-wrapper">
                        <span className="input-label">MSME Certificate{isStlDigital ? ' (Optional)' : '*'}</span>
                        <div
                            className="input-with-icon-vendor-form"
                            style={{ cursor: isDisabled ? 'not-allowed' : (uploaded.msme ? 'default' : 'pointer') }}
                            onClick={(e) => {
                                if (!isDisabled && !uploaded.msme) {
                                    msmeRef.current?.click();
                                }
                            }}
                        >
                            <input
                                type="text"
                                name="msme_number"
                                placeholder="MSME Number*"
                                value={vendorData.msme_number}
                                onChange={(e) => {
                                    handleVendorChange(e);
                                    setVerificationState(prev => ({
                                        ...prev,
                                        msme: { ...prev.msme, userModified: true }
                                    }));
                                }}
                                disabled={isDisabled}
                                readOnly={!uploaded.msme}
                            />
                            {uploaded.msme ? (
                                <FaTimesCircle
                                    className="remove-icon"
                                    style={{ color: 'green' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveFile('msme');
                                    }}
                                />
                            ) : (
                                <FaUpload className="upload-icon" />
                            )}
                            <input
                                type="file"
                                ref={msmeRef}
                                style={{ display: 'none' }}
                                accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
                                onChange={(e) => handleFileChange(e, 'msme_certificate')}
                                disabled={isDisabled}
                            />
                        </div>
                        {uploaded.msme && (
                            <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: getVerificationStatus("msme") === "Verified" ? "green" : "red"
                                }}>
                                    {getVerificationStatus("msme")}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {/* ASSESSMENT REPORT */}
                <div className="input-wrapper">
                    <span className="input-label">Assessment Report{isStlDigital ? ' (Optional)' : '*'}</span>
                    <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && !uploaded.assessment && assessmentRef.current?.click()}>
                        <input
                            type="text"
                            placeholder="Assessment Report*"
                            readOnly
                            value={uploaded.assessment ? fileNames.assessment : ""}
                            disabled={isDisabled}
                        />
                        {uploaded.assessment ? (
                            <FaTimesCircle
                                className="remove-icon"
                                style={{ color: 'green' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveFile('assessment');
                                }}
                            />
                        ) : (
                            <FaUpload className="upload-icon" />
                        )}
                        <input
                            type="file"
                            ref={assessmentRef}
                            style={{ display: 'none' }}
                            accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
                            onChange={(e) => handleStandardFileChange(e, 'assessment_report', 'assessment', true)}
                            disabled={isDisabled}
                        />
                    </div>
                </div>

                {/* NDA DOCUMENT */}
                <div className="input-wrapper">
                    <span className="input-label">NDA Document (Optional)</span>
                    <div className="input-with-icon-vendor-form" style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && !uploaded.nda && ndaRef.current?.click()}>
                        <input
                            type="text"
                            placeholder="NDA Document (Optional)"
                            readOnly
                            value={uploaded.nda ? fileNames.nda : ""}
                            disabled={isDisabled}
                        />
                        {uploaded.nda ? (
                            <FaTimesCircle
                                className="remove-icon"
                                style={{ color: 'green' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveFile('nda');
                                }}
                            />
                        ) : (
                            <FaUpload className="upload-icon" />
                        )}
                        <input
                            type="file"
                            ref={ndaRef}
                            style={{ display: 'none' }}
                            accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.doc,.docx"
                            onChange={(e) => handleStandardFileChange(e, 'nda_document', 'nda')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>

                {/* CIN NUMBER (STL-Digital - Always Visible) */}
                {isStlDigital && (
                    <div className="input-wrapper">
                        <span className="input-label">CIN Number (Optional)</span>
                        <input
                            type="text"
                            className="input-field"
                            name="cin_number"
                            placeholder="CIN Number (Optional)"
                            value={vendorData.cin_number}
                            onChange={handleVendorChange}
                            disabled={isDisabled}
                        />
                    </div>
                )}

            </div>
        </div >
    );
};

export default Step3_Tax;